import { useQuery } from '@tanstack/react-query';
import { useSearchParams } from 'react-router';
import { configurationProfileApi } from '../../../api/production/configuration-profiles';
import { technologyApi } from '../../../api/production/technologies';
import { Skeleton } from '../../../components/ui/skeleton';

export default function ConfigurationProfileUpdateFromOrderPage() {
  const [searchParams] = useSearchParams();
  const configuration_profile_id = searchParams.get('configuration_profile_id');
  const production_order_id = searchParams.get('production_order_id');
  const production_order_line_item_id = searchParams.get('production_order_line_item_id');

  const {
    data: configurationProfile,
    isLoading: isLoadingProfile,
    error: profileError,
  } = useQuery({
    queryKey: ['configuration-profile', configuration_profile_id],
    queryFn: () => configurationProfileApi.findOne(configuration_profile_id!),
    enabled: !!configuration_profile_id,
  });

  const { data: technology, isLoading: isLoadingTechnology } = useQuery({
    queryKey: ['technology', configurationProfile?.technology_id],
    queryFn: () => technologyApi.findOne(configurationProfile?.technology_id!),
    enabled: !!configurationProfile?.technology_id,
  });

  const isLoading = isLoadingProfile || isLoadingTechnology;

  if (!configuration_profile_id || !production_order_id || !production_order_line_item_id) {
    return (
      <div>
        <div className="flex flex-wrap items-center gap-6 px-4 sm:flex-nowrap sm:px-6 lg:px-8">
          <div>
            <h1 className="text-base font-semibold leading-7 text-gray-900">
              Parâmetros obrigatórios não fornecidos
            </h1>
          </div>
        </div>
      </div>
    );
  }

  if (isLoading) {
    return (
      <div>
        <div className="flex flex-wrap items-center gap-6 px-4 sm:flex-nowrap sm:px-6 lg:px-8">
          <div className="space-y-4">
            <Skeleton className="h-8 w-96" />
            <Skeleton className="h-5 w-64" />
          </div>
        </div>
        <div className="flex flex-wrap items-center gap-6 px-4 sm:flex-nowrap sm:px-6 lg:px-8">
          <div className="w-full space-y-4">
            <Skeleton className="h-64 w-full" />
            <Skeleton className="h-64 w-full" />
          </div>
        </div>
      </div>
    );
  }

  if (!configurationProfile || profileError) {
    return (
      <div>
        <div className="flex flex-wrap items-center gap-6 px-4 sm:flex-nowrap sm:px-6 lg:px-8">
          <div>
            <h1 className="text-base font-semibold leading-7 text-gray-900">
              Nenhum perfil de configuração encontrado
            </h1>
          </div>
        </div>
      </div>
    );
  }

  if (!technology) {
    return (
      <div>
        <div className="flex flex-wrap items-center gap-6 px-4 sm:flex-nowrap sm:px-6 lg:px-8">
          <div>
            <h1 className="text-base font-semibold leading-7 text-gray-900">
              Algumas informações do perfil de configurações não foram encontradas
            </h1>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div>
      <div className="flex flex-wrap items-center gap-6 px-4 sm:flex-nowrap sm:px-6 lg:px-8">
        <div>
          <h1 className="text-base font-semibold leading-7 text-gray-900">
            Atualização de perfil de configuração
          </h1>
          <p className="mt-1 text-sm leading-6 text-gray-600">
            Preencha o formulário abaixo para atualizar o perfil de configuração.
          </p>
        </div>
      </div>
      <div className="flex flex-wrap items-center gap-6 px-4 sm:flex-nowrap sm:px-6 lg:px-8">
        {/* TODO: Implement ConfigurationProfileUpdateFromProductionOrderForm component */}
        {/* For now, this is a placeholder showing that the form component needs to be migrated */}
        <div className="w-full">
          <div className="rounded-md bg-yellow-50 p-4">
            <div className="flex">
              <div className="ml-3">
                <h3 className="text-sm font-medium text-yellow-800">
                  Formulário em desenvolvimento
                </h3>
                <div className="mt-2 text-sm text-yellow-700">
                  <p>
                    O componente ConfigurationProfileUpdateFromProductionOrderForm ainda não foi
                    migrado.
                  </p>
                  <p className="mt-2">
                    <strong>Contexto:</strong>
                  </p>
                  <ul className="list-disc list-inside ml-4">
                    <li>Profile ID: {configuration_profile_id}</li>
                    <li>Order ID: {production_order_id}</li>
                    <li>Line Item ID: {production_order_line_item_id}</li>
                    <li>Client: {configurationProfile.manual_client ?? 'N/A'}</li>
                    <li>Technology: {technology.name.brand}</li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
